'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _storage = require('./storage');

var _storage2 = _interopRequireDefault(_storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  storage: _storage2.default
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/d2m-formiojs/lib/providers/index.js
// module id = 158
// module chunks = 0 1